export function useAlerts() {
  function showDeleteAlert(item: string, onDelete: () => void) {
    const confirmed = window.confirm(
      `Delete ${item}\n\nAre you sure you want to delete ${item}?`,
    )
    if (confirmed) {
      onDelete()
    }
  }

  function showDismissAlert(onDismiss: () => void) {
    const confirmed = window.confirm(
      'Do you really want to leave this screen?\n\nAll changes or data entered will be lost',
    )
    if (confirmed) {
      onDismiss()
    }
  }

  function unauthorizedAlert(context: string) {
    window.alert(
      `Unauthorized\n\nLooks like you have no access to this ${context}, please contact your site custodian.`,
    )
  }

  return { showDeleteAlert, showDismissAlert, unauthorizedAlert }
}
